import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function getProviderFiles(params: any = {}) {
  return request({
    url: 'provider-files/',
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function createProviderFile(data: any, idempotencyKey?: string) {
  return request({
    url: 'provider-files/',
    method: 'POST',
    data,
    headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
  }) as AxiosPromise;
}

export async function getProviderFile(id: number | string) {
  return request({
    url: `provider-files/${id}/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function updateProviderFile(id: number | string, data: any) {
  return request({
    url: `provider-files/${id}/`,
    method: 'PATCH',
    data,
  }) as AxiosPromise;
}

export async function changeProviderFileTransferType(id: number | string, data: any) {
  return request({
    url: `provider-files/${id}/change-transfer-type/`,
    method: 'PUT',
    data,
  }) as AxiosPromise;
}

export async function startProviderFile(id: number | string) {
  return request({
    url: `provider-files/${id}/start/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function closeProviderFile(id: number | string) {
  return request({
    url: `provider-files/${id}/close/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function cancelProviderFile(id: number | string, data: any) {
  return request({
    url: `provider-files/${id}/cancel/`,
    method: 'PUT',
    data,
  }) as AxiosPromise;
}

export async function releaseProviderFile(id: number | string) {
  return request({
    url: `provider-files/${id}/release/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function claimProviderFile(id: number | string) {
  return request({
    url: `provider-files/${id}/claim/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function getProviderFileCover(id: number | string) {
  return request({
    url: `provider-files/${id}/cover/`,
    method: 'GET',
    responseType: 'blob',
  }) as AxiosPromise<Blob>;
}

export async function getProviderFileAttachments(id: number | string) {
  return request({
    url: `provider-files/${id}/attachments/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function createProviderFileAttachment(id: number | string, data: any) {
  return request({
    url: `provider-files/${id}/attachments/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  }) as AxiosPromise;
}

export async function deleteProviderFileAttachment(id: number | string, attachmentId: number | string) {
  return request({
    url: `provider-files/${id}/attachments/${attachmentId}/`,
    method: 'DELETE',
  }) as AxiosPromise;
}

export async function getProviderFileChanges(id: number | string, params?: Record<string, unknown>) {
  return request({
    url: `provider-files/${id}/changes/`,
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function getProviderFileAffiliateFiles(id: number | string) {
  return request({
    url: `provider-files/${id}/affiliate-files/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function searchProviderFileAffiliateFiles(id: number | string, params: any = {}) {
  return request({
    url: `provider-files/${id}/affiliate-files/search/`,
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function createProviderFileAffiliateFile(id: number | string, data: any) {
  return request({
    url: `provider-files/${id}/affiliate-files/`,
    method: 'POST',
    data,
  }) as AxiosPromise;
}

export async function deleteProviderFileAffiliateFile(id: number | string, fileId: number | string) {
  return request({
    url: `provider-files/${id}/affiliate-files/${fileId}/`,
    method: 'DELETE',
  }) as AxiosPromise;
}

export async function getProviderFilePayments(id: number | string) {
  return request({
    url: `provider-files/${id}/payments/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function createProviderFilePayment(id: number | string, data: any) {
  return request({
    url: `provider-files/${id}/payments/`,
    method: 'POST',
    data,
  }) as AxiosPromise;
}

export async function updateProviderFilePayment(id: number | string, paymentId: number | string, data: any) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/`,
    method: 'PATCH',
    data,
  }) as AxiosPromise;
}

export async function cancelProviderFilePayment(id: number | string, paymentId: number | string) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/cancel/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function markProviderFilePaymentTransferred(id: number | string, paymentId: number | string) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/mark-transferred/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function confirmProviderFilePaymentReceipt(id: number | string, paymentId: number | string) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/confirm-receipt/`,
    method: 'PUT',
  }) as AxiosPromise;
}

export async function getProviderFilePaymentAttachments(
  id: number | string,
  paymentId: number | string,
) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/attachments/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function createProviderFilePaymentAttachment(
  id: number | string,
  paymentId: number | string,
  data: any,
) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/attachments/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  }) as AxiosPromise;
}

export async function deleteProviderFilePaymentAttachment(
  id: number | string,
  paymentId: number | string,
  attachmentId: number | string,
) {
  return request({
    url: `provider-files/${id}/payments/${paymentId}/attachments/${attachmentId}/`,
    method: 'DELETE',
  }) as AxiosPromise;
}

export async function getProviders(params: any = {}) {
  return request({
    url: 'providers/',
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function getProviderCBUs(providerId: number | string) {
  return request({
    url: `providers/${providerId}/cbus/`,
    method: 'GET',
  }) as AxiosPromise;
}
